import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Object Fusion B";

const callObjectFusionB = async (
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
				},
				jwt,
				tool_document_id,
			};
			return fetchObjectFusionB(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchObjectFusionB(
	params: {
		inputs: {
			$img: string;
		};
		jwt: string;
		tool_document_id: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenObjectFusionBMessage() {
	useListenFromRenderer([
		{
			key: "objectFusionB",
			onMessage: async (message) => {
				const success = await callObjectFusionB(
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
